import React from "react";

const YoucanbookmeIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("rect", {
  x: 3.33325,
  y: 3.33334,
  width: 33.3333,
  height: 33.3333,
  fill: "url(#pattern0)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_2069_808",
  transform: "scale(0.0125)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_2069_808",
  width: 80,
  height: 80,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAACMElEQVR4AWJwL/ABtHcPMHJFURzGY9W2bdu2bduOG6NBbdu2ESe1oppBbbf/+o7PrbvzveRb78NvMT5jrt+CCWlURzVD7VcX1QP16D/rgbqkDqhZqovKaHVws8KVU0vUU/U+gfZSrVRVfAAtv3FL1Ps4a5XK5AsYjNdY3VXv47THqrUPoIs3+NuKaKwF0MUbBJodMRivNlgRax4O0MVLol4CFbXU0QDXABSzXWEB9YlC4Jgr4wL6//bRbhfwI15i9Q4Yr9K6gB3/pZ2LtPxjgH1dwHkAerfSBTwEoHdnXcArAHp32wV8CKB3D13AxwB699gFfPTnD/i/XJ/bIwABtAUggPavAxDA/wcw0gIggAAC+C8CGgMQQAAB5EQEQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQEMAAggggJyIGAIQQAABfJyw7lz05x/q9RDAn3uw4VXvFfCgxNsu4BEAvTvvAi4A0Ls1LmA3AL0b6AKm8F4BZQoevLMJFHMHw00uKg6MuUqRho9tASdmh6JNb0vBCKiYZYg1gLEpSBFrYx0BOgaskIZ8sSlpHUI7DrRvDVVJ1TQ1Us1SVS1jkNup53EM90Z1+WIxXo1TQ9RgNck6iDubWh+HeFtVni8GFVVXlVc9VCVUc99R8DXVBvUmDuDqBR17SjVZ9Va1vmBOCwa0QmZRfdQSdUzd+E+fjOChuqFOqOWqv8oV5bgrqwVq0JfXtQ2AZOhnAekDkct4TkPB0/QAAAAASUVORK5CYII="
})));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(YoucanbookmeIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;